import React from 'react'

import { PageLinksDataType } from '@contracts/content/pageLinks'

import PageLink from './PageLink'
import * as styles from './PageLinks.module.scss'

interface Props {
	data: PageLinksDataType
}

const PageLinks: React.FunctionComponent<Props> = ({ data }) => {
	const { pageLinks } = data

	return (
		<>
			{pageLinks && (
				<ul className={styles.pageLinks}>
					{pageLinks.map((pageLink, index) => {
						if (!pageLink.link) return null

						return (
							<li key={index}>
								<PageLink data={pageLink} />
							</li>
						)
					})}
				</ul>
			)}
		</>
	)
}

export default PageLinks
